import { FileDropzone } from 'lead-list/components/FileDropzone';
import { PageHeading } from 'lead-list/components/PageHeading';
import { Paper } from 'lead-list/components/Paper';
import { GlobalState, useStateMachine } from 'little-state-machine';
import { FC, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { STEPS } from '../../LeadListCreate';
import { Nav } from '../Nav';
import { StepContainer } from '../StepContainer';
import messages from './messages';

function updateFile(state: GlobalState, file: File | null) {
  return {
    ...state,
    leadListCreate: {
      ...state.leadListCreate,
      file,
      fileProcessed: false,
    },
  };
}

function setHasSeenFileUpload(state: GlobalState, hasSeen: boolean) {
  return {
    ...state,
    leadListCreate: {
      ...state.leadListCreate,
      hasSeenFileUpload: hasSeen,
    },
  };
}

export const StepSelectFile: FC = () => {
  const { formatMessage } = useIntl();

  const navigate = useNavigate();
  const {
    actions,
    state: { leadListCreate },
  } = useStateMachine({ updateFile, setHasSeenFileUpload });
  const [goGreen, setGoGreen] = useState(false);
  const [goRed, setGoRed] = useState(false);
  const hasDroppedFileRef = useRef(false);

  const nextStep = () => {
    setGoGreen(true);
    actions.setHasSeenFileUpload(true);
    setTimeout(() => {
      navigate(STEPS.selectCampaign);
    }, 300);
  };

  const markError = () => {
    setGoRed(true);
    setTimeout(() => {
      setGoRed(false);
    }, 5000);
  };

  const selectFile = (file: File) => {
    if (!file) return;
    hasDroppedFileRef.current = true;
    actions.updateFile(file);
  };

  useEffect(() => {
    if (!hasDroppedFileRef.current) return;

    if (leadListCreate.fileProcessed && !leadListCreate.fileProcessingError) {
      nextStep();
    } else if (leadListCreate.fileProcessingError) {
      markError();
    }
  }, [leadListCreate.fileProcessed, leadListCreate.fileProcessingError]);

  return (
    <StepContainer>
      <PageHeading title={formatMessage(messages.uploadTitle)} />

      <Paper
        variant="outlined"
        shade={goGreen ? 'success' : goRed ? 'error' : undefined}
        sx={(theme) => ({
          width: '100%',
          padding: theme.spacing(3),
        })}
      >
        <FileDropzone
          selectedFile={leadListCreate.file}
          onDrop={(acceptedFiles, _fileRejections) => {
            if (acceptedFiles[0]) {
              selectFile(acceptedFiles[0]);
            } else {
              console.error('Error getting file');
            }
          }}
          allowedFileTypes=".csv"
        />
      </Paper>
      <Nav
        onForwardClick={leadListCreate.hasSeenFileUpload ? nextStep : undefined}
        disableBack={goGreen}
        disableForward={goGreen}
      />
    </StepContainer>
  );
};
